"use strict";
host.plugins.register({
    // #region Vars
    name: "288a.web.admin",
    // #endregion
    // #region Register
    register() {
        host.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
    },
    // #endregion
});
